import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import Content from './components/Content';
import Footer from '../../shared/components/PublicPageFooter';
import Header from '../../shared/components/PublicPageHeader';
import MethodAlreadySelected from './components/MethodAlreadySelected';
import OrderApprovedScreen from './components/OrderApprovedScreen';
import InvalidOrderStatus from './components/InvalidOrderStatus';
import { LoadingPage } from '../../shared/components/LoadingPage';
import useSetFavicon from '../../shared/hooks/useSetFavicon';
import usePageStore from './store/pageStore';
import Services from './services';
import { GeneralContext } from '../../core/app-context/GeneralContext';
import useGetConfigs from './hooks/useGetConfigs';
import useConfigsStore from './store/configsStore';
import ExpiredOrder from './components/ExpiredOrder';

export function PublicSelectReturnLocation() {
  useGetConfigs();
  const { orderId } = useParams();
  const { setErrorMessage } = useContext(GeneralContext);

  const loadingConfigs = useConfigsStore((state) => state.loadingConfigs);
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const storeConfigs = useConfigsStore((state) => state.storeConfigs);
  const order = useConfigsStore((state) => state.order);
  const setOrderAsMethodSelected = useConfigsStore(
    (state) => state.setOrderAsMethodSelected,
  );
  const setOrderAsApproved = useConfigsStore(
    (state) => state.setOrderAsApproved,
  );
  const selectedReturnMethod = usePageStore(
    (state) => state.selectedReturnMethod,
  );
  const selectedLocker = usePageStore((state) => state.selectedLocker);
  const setIsProcessingOrder = usePageStore(
    (state) => state.setIsProcessingOrder,
  );
  const disableHeader = usePageStore((state) => state.disableHeader);

  useSetFavicon(devolutionPageConfigs?.faviconUrl);

  const handleSelectReturnMethod = async () => {
    setIsProcessingOrder(true);
    const setReturnMethodResult = await Services.setOrderReturnMethod({
      orderId,
      returnMethodIndex: selectedReturnMethod,
      boxCode: selectedLocker?.boxCode,
    });
    if (!setReturnMethodResult.success) {
      setErrorMessage(setReturnMethodResult.message);
      setIsProcessingOrder(false);
      return;
    }
    if (storeConfigs?.autoApproveDevolution) {
      const approveOrderResult = await Services.approveOrRejectOrder({
        orderId,
        choice: true,
      });
      if (!approveOrderResult) {
        setErrorMessage('Erro ao aprovar a devolução, contate o lojista');
        setIsProcessingOrder(false);
        return;
      }
      if (selectedReturnMethod === 1) {
        setOrderAsApproved({
          returnMethodIndex: selectedReturnMethod,
          info: {
            expressNumber: approveOrderResult.expressNumber,
            qrCodeUrl: approveOrderResult.qrCodeUrl,
            selectedLockerAddress: approveOrderResult.selectedLockerAddress,
            orderApprovedTemplateEmailHtml:
              approveOrderResult.orderApprovedTemplateEmailHtml,
          },
        });
      }
      if (selectedReturnMethod === 2) {
        setOrderAsApproved({
          returnMethodIndex: selectedReturnMethod,
          info: {
            correiosPostageNumber: approveOrderResult.correiosPostageNumber,
          },
        });
      }
    } else {
      setOrderAsMethodSelected(selectedReturnMethod);
    }
    setIsProcessingOrder(false);
  };

  if (loadingConfigs) {
    return <LoadingPage />;
  }
  
  const selectedStatus = order?.status?.index === 2;
  const approvedStatus = order?.status?.index === 3;
  const rejectedStatus = order?.status?.index === 7;
  const invalidStatus = order?.status?.index > 3;
  const expirationDate = order?.expirationDate
    ? new Date(order.expirationDate)
    : null;
  const expiredOrder = expirationDate && expirationDate < new Date();
  return (
    <>
      {!disableHeader && (
        <Header
          logoUrl={devolutionPageConfigs?.logoUrl}
          showCRLogo={approvedStatus && order?.returnMethod?.index === 1}
          color={devolutionPageConfigs?.headerFooterColor}
        />
      )}
      {(() => {
        if (expiredOrder)
          return <ExpiredOrder expirationDate={expirationDate} />;
        if (selectedStatus) return <MethodAlreadySelected />;
        if (approvedStatus) return <OrderApprovedScreen />;
        if (invalidStatus) return <InvalidOrderStatus />;
        return <Content submit={handleSelectReturnMethod} />;
      })()}
      <Footer
        instaAccount={devolutionPageConfigs?.instagramAccount}
        fbAccount={devolutionPageConfigs?.facebookAccount}
        linkedinAccount={devolutionPageConfigs?.linkedinAccount}
        tiktokAccount={devolutionPageConfigs?.tiktokAccount}
        link1Title={devolutionPageConfigs?.link1Title}
        link1Url={devolutionPageConfigs?.link1Url}
        link2Title={devolutionPageConfigs?.link2Title}
        link2Url={devolutionPageConfigs?.link2Url}
        color={devolutionPageConfigs?.headerFooterColor}
        fontColor={devolutionPageConfigs?.footerIconsColor || '#ffffff'}
      />
    </>
  );
}
